var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifierNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_78915",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_78915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52942 13.4706H10.647V12.0589H4.52942V13.4706ZM4.52942 9.70586H13.4706V8.29414H4.52942V9.70586ZM4.52942 5.94114H13.4706V4.52942H4.52942V5.94114ZM2.70137 17C2.22595 17 1.82353 16.8353 1.49412 16.5059C1.16471 16.1765 1 15.774 1 15.2986V2.70137C1 2.22595 1.16471 1.82353 1.49412 1.49412C1.82353 1.16471 2.22595 1 2.70137 1H15.2986C15.774 1 16.1765 1.16471 16.5059 1.49412C16.8353 1.82353 17 2.22595 17 2.70137V15.2986C17 15.774 16.8353 16.1765 16.5059 16.5059C16.1765 16.8353 15.774 17 15.2986 17H2.70137ZM2.70137 15.5883H15.2986C15.371 15.5883 15.4374 15.5581 15.4978 15.4978C15.5581 15.4374 15.5883 15.371 15.5883 15.2986V2.70137C15.5883 2.62896 15.5581 2.56258 15.4978 2.50224C15.4374 2.44191 15.371 2.41175 15.2986 2.41175H2.70137C2.62896 2.41175 2.56258 2.44191 2.50224 2.50224C2.44191 2.56258 2.41175 2.62896 2.41175 2.70137V15.2986C2.41175 15.371 2.44191 15.4374 2.50224 15.4978C2.56258 15.5581 2.62896 15.5883 2.70137 15.5883Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifierNote);
export default __webpack_public_path__ + "static/media/modifierNote.f21fb46e182a8f2f811effb18d03942b.svg";
export { ForwardRef as ReactComponent };